import Tooltip, { TooltipProps } from '@mui/material/Tooltip';
import { FC } from 'react';

export const TooltipBase: FC<TooltipProps> = (props) => {
  // Disabled elements do not trigger mouse events, adding a non-disabled element such as
  // a <span> wrapper solves this problem
  return <Tooltip arrow {...props} />;
};
